export default __webpack_public_path__ + "static/media/empty_avatar.cedf234c.png";